import { defineMessages } from 'react-intl';

export const title = defineMessages({
  ngeeann: {
    id: 'pages.about.ngeeann.title',
    defaultMessage: 'About Ngee Ann Polytechnic',
  },
  sginnovate: {
    id: 'pages.about.sginnovate.title',
    defaultMessage: 'About SGInnovate',
  },
  indorse: {
    id: 'pages.about.indorse.title',
    defaultMessage: 'About Indorse',
  },
});

export const content = defineMessages({
  ngeeannOne: {
    id: 'pages.about.ngeeann.one',
    defaultMessage:
      'We opened our doors with just 116 students in 1963 and offered courses in language, commerce and technology. Five decades on, we have never stopped preparing students for the challenges of their time.',
  },
  ngeeannTwo: {
    id: 'pages.about.ngeeann.two',
    defaultMessage:
      'Today Ngee Ann Polytechnic offers 36 full-time diploma courses and three common entry programmes through nine academic schools, and various part-time programmes for adult learners through our CET Academy. We have a student population of more than 14,000. Our alumni community of over 145,000 is ever growing, with many living in other parts of the world still calling us home. Every step of the way, we have been unwavering in our commitment to give students an outstanding learning journey.',
  },
  ngeeannThree: {
    id: 'pages.about.ngeeann.three',
    defaultMessage:
      "With its emphasis on broad-based learning, global exposure and character development, Ngee Ann Polytechnic's mission is to develop students who are confident, self-directed, innovative and adaptable – equipped for success in the future economy.",
  },
  sginnovateOne: {
    id: 'pages.about.sginnovate.one',
    defaultMessage:
      "At SGInnovate, we believe that Singapore has the resources & capabilities needed to tackle 'hard problems' that matter to people around the world.",
  },
  sginnovateTwo: {
    id: 'pages.about.sginnovate.two',
    defaultMessage:
      'As part of our Deep Tech Nexus Strategy, we are focused on adding tangible value to the Singapore deep tech startup ecosystem in two key areas - development of Human Capital and deployment of Investment Capital.',
  },
  sginnovateThree: {
    id: 'pages.about.sginnovate.three',
    defaultMessage:
      'Our efforts are also prioritised around identifying and building deep tech talents with world-class learning opportunities.',
  },
  indorseOne: {
    id: 'pages.about.indorse.one',
    defaultMessage:
      'Indorse is revolutionizing the way skills are validated. It provides a decentralized platform for candidates to receive skills assessment through an anonymous consensus of experienced professionals and experts.',
  },
});



// WEBPACK FOOTER //
// ./src/ui/pages/about-us/messages.js